<template>
  <v-card class="pa-6">
    <ModalPercentualRateio
      :selectedItem="selectedItem"
      :dialog="dialogConsultaPercentual"
      @update:dialog="dialogConsultaPercentual = $event"
    />
    <ModalContabilizar
      :labelBtn="labelBtn"
      :dialog="dialog"
      :selectedItem="selectedItem"
      @update:dialog="dialog = $event"
      @onUpdateEnd="fetchContabilizar(filter)"
    />

    <ModalProduct
      :dialog.sync="dialogProcutc"
      :idNcm="ncm"
      @update:dialog="dialogProcutc = $event"
    />
    <BaseDataTable
      :headers="headerTable"
      :items="itemsContabilizar"
      @pageChange="fetchContabilizar({ ...filter, page: $event })"
      :paginate="true"
      :currentPage="currentPage"
      :lastPage="lastPage"
      :items-per-page="8"
      :loading="loading"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="id_contabilizacao_ncm"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="8" lg="8" class="pa-0"> </v-col>
          <v-col cols="12" md="4" lg="4" class="pa-0">
            <MenuFilterSearchTable
              :placeholder="'Buscar por NCM ou descrição'"
              :textQuery="'ncm_descricao'"
              :codQuery="'nfe_ncm'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>

      <!-- ---------------- header ---------------- -->
      <template v-slot:header.nfe_ncm="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="header.text"
            :query="header.value"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.cod_contabil="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="header.text"
            :query="header.value"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.conta_contabil="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="header.text"
            :query="header.value"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.schema_nbs="{ header }">
        <span>
          {{ header.text }}
          <MenuFilterSelect
            :items="[
              { shema: 'NBS', descricao: 'NBS' },
              { shema: 'CCV', descricao: 'CCV' },
            ]"
            :itemText="'descricao'"
            :itemValue="'shema'"
            :label="header.text"
            :query="header.value"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilterSelect>
        </span>
      </template>

      <template v-slot:header.pode_alterar="{ header }">
        <span>
          {{ header.text }}
          <MenuFilterSelect
            localFilter="api"
            :items="[
              { status: '0', descricao: 'Sem conta' },
              { status: '1', descricao: 'Validado' },
              { status: '2', descricao: 'Não Validado' },
            ]"
            :itemText="'descricao'"
            :itemValue="'status'"
            :label="header.text"
            :query="'status'"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilterSelect>
        </span>
      </template>

      <!-- ---------------- items ---------------- -->
      <template v-slot:item.nfe_ncm="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{ item.nfe_ncm }}</span>
          </template>

          <span
            ><p>{{ formatText(item.descricao_concatenado) }}</p></span
          >
        </v-tooltip>
      </template>

      <template v-slot:item.cod_contabil="{ item }">
        {{ item.cod_contabil | defaultValue | TitleCase }}
      </template>
      <template v-slot:item.cod_contab_padrao="{ item }">
        {{ item.cod_contab_padrao || "Sem conta contábil" }}
      </template>
      <template v-slot:item.ncm_descricao="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <p v-bind="attrs" v-on="on" class="limita-descricao">
              {{ item.ncm_descricao }}
            </p>
          </template>
          <span>{{ item.ncm_descricao }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.conta_contabil="{ item }">{{
        item.conta_contabil | defaultValue | TitleCase
      }}</template>
      <template v-slot:item.pode_alterar="{ item }">
        <v-chip :color="colorChip(item.status)" :class="'white--text'">{{
          statusText[item.status] | TitleCase
        }}</v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <!-- <div
          v-can:role="['contabilidade', 'concessionaria']"
          class="d-flex justify-end"
        > -->
        <div class="d-flex justify-end">
          <v-tooltip
            v-can:permission="'nfe-ncm-contabilizar#list-all'"
            top
            v-if="item.conta_contabil"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="openConsultaPercentual(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Consultar percentual de rateio padrão</span>
          </v-tooltip>

          <v-tooltip v-can:permission="'nfe-ncm-contabilizar#update'" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="openModalEdit(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="openModalProducts(item.nfe_ncm)"
              >
                <v-icon>mdi-cart-variant</v-icon>
              </v-btn>
            </template>
            <span>Produtos</span>
          </v-tooltip>
        </div>
      </template>
    </BaseDataTable>
  </v-card>
</template>

<script>
import BaseDataTable from "@/components/BaseDataTable.vue";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import MenuFilterSelect from "@/components/MenuFilterSelect.vue";
import nfeNcm from "@/services/http/nfeNcm/NfeNcm.js";
import { permissions } from "@/store/permissionsStore";
import ModalContabilizar from "./ModalContabilizar";
import ModalPercentualRateio from "./ModalPercentualRateio.vue";
import ModalProduct from "./ModalProduct";

export default {
  components: {
    MenuFilter,
    MenuFilterSelect,
    MenuFilterSearchTable,
    ModalContabilizar,
    ModalProduct,
    BaseDataTable,
    ModalPercentualRateio,
  },

  filters: {
    defaultValue: (value) => (value ? value : "Não informado"),
  },

  data() {
    return {
      labelBtn: "",
      statusText: {
        0: "Sem conta",
        1: "Validado",
        2: "Não Validado",
      },
      selectedItem: {},

      filter: {},
      expanded: [],
      singleExpand: false,
      dialog: false,
      dialogRateio: false,
      dialogProcutc: false,
      ncm: "",
      currentPage: 1,
      lastPage: 1,
      loading: false,
      itemsContabilizar: [],
      dialogConsultaPercentual: false,
      realSchemaName: {
        NBS: "2 Rodas",
        CCV: "4 Rodas",
      },

    };
  },
  watch: {
    filter(value) {
      this.fetchContabilizar(value);
    },
  },

  computed: {
    headerTable() {
      const permissionUser = permissions();

      let headers = [
        {
          text: "NFe-NCM",
          value: "nfe_ncm",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "Descrição",
          value: "ncm_descricao",
          filterable: false,
          sortable: false,
          width: 350,
        },
        {
          text: "Cód. Contabil",
          value: "cod_contabil",
          filterable: false,
          sortable: false,
        },
        {
          text: "Conta Contabil",
          value: "conta_contabil",
          filterable: false,
          sortable: false,
        },
        {
          text: "Cód. Contabilização Padrão",
          value: "cod_contab_padrao",
          filterable: false,
          align: "center",
        },
        {
          text: "Schema",
          value: "schema_nbs",
          filterable: false,
          sortable: false,
        },
        {
          text: "Status",
          value: "pode_alterar",
          align: "center",
          filterable: false,
          sortable: false,
        },
      ];
        
      if (permissionUser.getPermissions['nfe-ncm-contabilizar'].includes('list-all', 'update')) {
        headers.push({
          text: "Ações",
          value: "actions",
          align: "right",
          filterable: false,
          sortable: false,
        });

      }
      return headers;
    }
  },

  methods: {
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },

    changeSchemaName(schema) {
      if (schema != undefined) {
        return this.realSchemaName[schema];
      }
      return "Não registrado!";
    },

    formatText(text) {
      return text.replaceAll('"', "");
    },

    colorChip(status) {
      const objectStatus = {
        0: "#757575",
        1: "#43A047",
        2: "#E53935",
      };

      return objectStatus[status];
    },

    openModal() {
      this.dialog = true;
      this.labelBtn = "Cadastrar";
    },

    openModalEdit(item) {
      this.dialog = true;
      this.labelBtn = "Editar";
      this.selectedItem = item;
    },

    openConsultaPercentual(item) {
      this.dialogConsultaPercentual = true;
      this.selectedItem = item;
    },
    openModalProducts(idNcm) {
      this.dialogProcutc = true;
      this.ncm = idNcm;
    },

    async fetchContabilizar(filter = {}) {
      try {
        this.loading = true;
        let { data } = await nfeNcm().contabilizarShow({
          "orderBy[desc]": "cod_contabil",
          per_page: 8,
          ...filter,
        });
        this.itemsContabilizar = data.data;

        this.loading = false;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
      } catch (error) {
        console.error(error);
      }
    },
  },

  created() {
    this.fetchContabilizar();
  },
};
</script>

<style>
.v-tooltip__content {
  max-width: 600px;
}
</style>
